import { render, staticRenderFns } from "./MedOcuOtros.vue?vue&type=template&id=7cc0a1cd&scoped=true"
import script from "./MedOcuOtros.vue?vue&type=script&lang=js"
export * from "./MedOcuOtros.vue?vue&type=script&lang=js"
import style0 from "./MedOcuOtros.vue?vue&type=style&index=0&id=7cc0a1cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc0a1cd",
  null
  
)

export default component.exports